// External libraries
import { css } from '@emotion/core';

const logInButtonStyles = css`
  color: white;
  font-size: 13px;
  height: 30px;
  line-height: 1.38;
  min-width: 96px;
  padding: 0 16px;
  width: auto;
`;

const mainStyles = css`
  display: flex;
  flex-direction: column;
`;

const nonBaslLinkStyles = css`
  margin-bottom: 23.5px;
  text-align: center;
`;

export { logInButtonStyles, mainStyles, nonBaslLinkStyles };
